import { OVERRIDE_TYPE_META } from '../../telas/aprovacao-overrides/tela9-adapter';

import type { OverrideType } from '../../types';
import type React from 'react';

// Forma curta para o badge (espelha badges-3.jsx:104-121, em snake_case canônico).
const SHORT: Record<OverrideType, string> = {
  ai_required_validation: 'Validação da IA',
  carencia_proativa: 'Carência proativa',
  gatilho_protecao: 'Gatilho proteção',
  modo_operacao: 'Modo operação',
  capability_temporaria: 'Capability temporária',
  legal_capacity_exception: 'Capacidade legal',
  conflict_alert_accept: 'Aceite de conflito',
  h_c_adversarial_strict: 'H_c adversarial',
};

export function OverrideTypeBadge({
  type,
  urgent = false,
}: {
  type: OverrideType;
  urgent?: boolean;
}): React.JSX.Element {
  return (
    <span className={`override-type ${urgent ? 'override-type--urgent' : ''}`}>
      {SHORT[type] ?? OVERRIDE_TYPE_META[type].label}
      {urgent && (
        <span className="override-type__urgent-dot" aria-label="Urgente">
          ⚠
        </span>
      )}
    </span>
  );
}
